import React from 'react'
import { Route } from 'react-router-dom'

export default ({ component: C, ...routeProps }) => {
  return <Route {...routeProps} render={props => <C {...props} />} />
}
